// @flow

import { RECEIVED_FORM_SETTINGS } from './constants';
import type { TemplateFormSettings } from '../../types';

export type ReceivedFormSettings = {|
  type: typeof RECEIVED_FORM_SETTINGS,
  payload: TemplateFormSettings,
|};

export const receivedFormSettings = (data: TemplateFormSettings): ReceivedFormSettings => ({
  type: RECEIVED_FORM_SETTINGS,
  payload: Object.assign(data, {
    income_sources: {
      ...data.income_sources,
    },
  }),
});

export default null;
